// extracted by mini-css-extract-plugin
module.exports = {"resultItems":"resultItems_2cxlaAWP","results":"results_2SVPScnX","column":"column_1X-TqOkq"};